import React from 'react';

const LoadingSpinner = ({
  size = 'lg',
  message = 'Loading...',
  inline = false,
  color = 'text-indigo-600',
  className = '',
  showMessage = true,
  center = true,
  fullScreen = false
}) => {
  const sizeClasses = {
    xs: 'h-3 w-3',
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  };

  const SpinnerSVG = () => (
    <svg
      className={`animate-spin ${center ? 'mx-auto' : ''} ${sizeClasses[size]} ${color}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      ></circle>
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 0 1 4 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  );

  // For inline usage (just the spinner)
  if (inline) {
    return <SpinnerSVG />;
  }

  // For full loading states
  const containerClass = fullScreen
    ? 'min-h-screen bg-gray-50'
    : 'min-h-[calc(100vh-8rem)]';

  return (
    <div className={`flex items-center justify-center ${containerClass} ${className}`}>
      <div className="text-center">
        <SpinnerSVG />
        {showMessage && message && (
          <p className="mt-4 text-sm text-gray-600">{message}</p>
        )}
      </div>
    </div>
  );
};

export default LoadingSpinner;